export const STRUCTURE_RESET = "STRUCTURE_RESET";
export const STRUCTURE_SET_ERROR = "STRUCTURE_SET_ERROR";
export const STRUCTURE_SET_ITEMS = "STRUCTURE_SET_ITEMS";
export const STRUCTURE_TOGGLE_LOADING = "STRUCTURE_TOGGLE_LOADING";
